import { Injectable, asNativeElements } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';

import { ENPOINT } from '../endpoint';
import { Options } from 'selenium-webdriver/safari';

import { GLOBAL } from '../global';


@Injectable()
export class WarehouseService {

  public url = GLOBAL.url;
  private basePath

  constructor(
    private http: HttpClient,
    
  ) {
    this.basePath = ENPOINT.url;
  }


  //ASN OBTENER ASN PENDIENTES

getASN(iestatus,itipo): Observable<any>{
  let estatus = iestatus;
  let tipo = itipo;
  const httpHeaders = new HttpHeaders();
  const options = {
    headers: httpHeaders,
    withCredentials: true,
    params: new HttpParams()
    .set('estatus', estatus)
    .set('tipo', tipo)
    
  };
  return this.http.get(this.basePath + 'Asn', options);


}

  //ASN OBTENER POSICIONES DEL PEDIDO 
getASNPositions(asnId):Observable<any>{

  const httpHeaders = new HttpHeaders();
  const options = {
    headers: httpHeaders,
    withCredentials: true
  };
  return this.http.get(this.basePath + 'Asn/'+asnId, options);


}

  //VERIFICAR PRODUCTO EN ASN
checkProductOnASN(asnId, posId, identificador) {

  let asn = asnId;
  let pos = posId;
  let id = identificador;

  const httpHeaders = new HttpHeaders();
  const options = {
    headers: httpHeaders,
    withCredentials: true,
    params: new HttpParams()
    .set('identificador', identificador)
  };
  return this.http.get<any>(this.basePath + 'Asn/' + asn + '/' + pos, options);


}

  //CREAR CORRESPONDIENTE ASN 
  crearEM(ordenCompra, idASN): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };
    return this.http.put(this.basePath + 'Asn/crearEM/4500000874/' + idASN, '', options);
  }



}



// WEBPACK FOOTER //
// ./src/app/services/warehouse/warehouse.service.ts